import { useId } from "react";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { cn } from "lib/utils";

type Props = {
  label: string;
  time: string;
  setTime: React.Dispatch<React.SetStateAction<string>>;
  /**
   * Precisão do campo em segundos. O padrão é 60 (minutos): janela de coleta
   * com precisão de segundo não existe, e `step="1"` fazia o navegador exibir
   * "00:00:00".
   */
  step?: number;
  className?: string;
};

const InputTime = ({ label, setTime, time, step = 60, className }: Props) => {
  // O id era fixo ("time-picker"). Com dois campos na mesma tela — início e
  // fim da janela — os dois ficavam com o mesmo id, e clicar na label do
  // segundo focava o primeiro.
  const id = useId();

  return (
    <div className="flex flex-col">
      <Label htmlFor={id} className="px-1 text-brand-text">
        {label}
      </Label>
      <Input
        type="time"
        id={id}
        step={step}
        value={time}
        onChange={(e) => setTime(e.target.value)}
        className={cn(
          "bg-white text-brand-text py-[21px] appearance-none [&::-webkit-calendar-picker-indicator]:appearance-none",
          className,
        )}
      />
    </div>
  );
};
export default InputTime;
